export default `
  @import url('https://fonts.googleapis.com/css?family=Work+Sans:200,300,400,500');
`


// WEBPACK FOOTER //
// ./src/ui/styles/fonts.js